import { FC } from 'react';
import { useHistory } from 'react-router';
import { Icon } from './Icon';

interface DirectoryBarProps {
  text: any;
  className?: string;
  backArrow?: boolean;
}

export const DirectoryBar: FC<DirectoryBarProps> = ({
  text,
  backArrow,
  className,
}) => {
  const { goBack } = useHistory();
  return (
    <>
      <div
        className={`${className} border-b pb-4 pt-4 pl-4 md:pl-6 md:py-4 -mx-4 mb-4 flex items-center space-x-2`}
      >
        {backArrow && (
          <button onClick={goBack} className="">
            <Icon.ArrowLeft />
          </button>
        )}
        <p>{text}</p>
      </div>
    </>
  );
};
